import type { ErrorInfo } from 'react'
import { EventBus, globalEventBus } from '../../core/events'
import { ErrorLevel } from '../constants'
import { PlatformError } from './errors'
import type { ErrorEventType } from '../types'

/**
 * Callback to use in error boundaries, and error handler in side effects. Emits
 * caught errors to the event bus so they can be picked up elsewhere for logging
 * etc.
 *
 * @param error The error caught, maybe by a boundary
 * @param info Additional info from a boundary callback, if present
 * @param level The boundary level where the error was caught, if present
 */
export const emitError = (
  error: PlatformError | unknown,
  info?: ErrorInfo,
  level?: ErrorLevel,
) => {
  const eventBus = globalEventBus as EventBus<ErrorEventType>

  eventBus.emit({
    topic: 'framework:error:v1',
    payload: { error, info, level },
  })
}
